import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';

import { CustomElement, EntityService, ModalService, Model, QuickAdditModal, ToolbarService } from '@kaiser-software/chassis-core';

import { LocationService } from '../../services/location.service';
import { LocationModel } from '../../models/location.model';
import { LocationEditModal } from '../../modals/edit/edit.modal';

@Component({
    selector: 'donna-locations-settings-plugin',
    templateUrl: './location-settings.plugin.html',
    styleUrls: ['./location-settings.plugin.scss']
})
export class LocationSettingsPlugin extends CustomElement implements OnInit, OnDestroy {

    @Input() public form;

    protected table;

    protected entityService: EntityService;

    protected locationService: LocationService;

    protected modalService: ModalService;

    protected toolbarService: ToolbarService;

    protected datatableInstance;

    constructor(protected injector: Injector) {
        super();

        this.entityService   = this.injector.get(EntityService);
        this.locationService = this.injector.get(LocationService);
        this.modalService    = this.injector.get(ModalService);
        this.toolbarService  = this.injector.get(ToolbarService);
    }

    ngOnInit() {
        if (!this.val) {
            this.val = {};
        }

        this.createDatatable();
    }

    protected createDatatable() {
        this.table = {
            callbacks: {},
            columns: [],
        };

        this.table.service = this.locationService;

        this.createDatatableColumns();

        this.table.ajax = this.table.service.all(true, {
            datatable: true,
        });

        const self = this;

        this.table.callbacks['click'] = (data) => {
            const model = LocationModel.make(data, this.locationService);

            const modal = this.modalService.open(QuickAdditModal, {entity: 'location', entityId: data.id});

            modal.result.then((result: Model) => {
                this.refreshDatatable();
            });

            // const modal = this.modalService.open(LocationEditModal, {
            //     showDeleteButton: true,
            //     model: model,
            //     onSave() {
            //         self.refreshDatatable();
            //     },
            // });
        };
    }

    /**
     * Create the datatable columns.
     */
    protected createDatatableColumns() {
        if (!this.table.columns || this.table.columns.length === 0) {
            this.table.columns = [];

            if (this.table.service && this.table.service.entityName) {
                this.table.columns = this.table.columns.concat(this.entityService.getDatatableColumns(this.table.service.entityName));
            }
        }
    }

    protected create() {

        const modal = this.modalService.open(QuickAdditModal, {entity: 'location'});

        modal.result.then((result: Model) => {
            this.refreshDatatable();
        });

        // const self = this;
        //
        // const modal = this.modalService.open(LocationCreateModal, {
        //     onSave(data) {
        //         self.refreshDatatable();
        //     },
        // });
    }

    protected setDatatableInstance(event) {
        console.log(event);
        this.datatableInstance = event;
    }

    protected refreshDatatable() {
        if (this.datatableInstance) {
            this.datatableInstance.refresh();
        }
    }

    ngOnDestroy() {
    }

}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/locations/plugins/location-settings/location-settings.plugin.ts